import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { createSx } from '../../utils';
import AnimationImage from './AnimationImage';

export interface Props {
  status?: string | number;
  message?: React.ReactNode;
}

const sx = createSx({
  wrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    background: theme => theme.palette.neutral.containerHighest,
  },
  img: {
    width: 480,
    height: 250,
    maxWidth: {
      xs: 300,
      md: '100%',
    }
  },
  code: {
    color: 'info.dark',
    margin: theme => theme.spacing(7, 0, 1),
  },
  message: {
    color: 'neutral.onSurfaceVariant',
  },
});

const ErrorPage = ({ status, message }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={sx.wrapper} data-test-id='error-page'>
      <Box sx={sx.img} >
        <AnimationImage />
      </Box>
      {status && <Typography
        sx={sx.code}
        variant='h2'
        component='h1'
        data-test-id='error-page-status'
      >
        {status}
      </Typography >}
      <Typography
        sx={sx.message}
        variant='h5'
        component='div'
        data-test-id='error-page-message'
      >
        {message || t('somethingWentWrong')}
      </Typography>
    </Box>
  );
};
export default ErrorPage;
